import "phaser";
import App from '../main';
import { RoadPiece } from "../Sprites/RoadPiece";
import { RoadType } from "../Sprites/RoadPiece";
import { Direction } from "../app/game";
import { Game } from '../app/game'
import ControlPoint from "../Sprites/ControlPoint";
import { Gem } from "../Sprites/Gem";
export default class RoadGenerator {

  roadPieces: RoadPiece[];
  public controlPoints: ControlPoint[];

  straightRoads: Phaser.GameObjects.Group;
  uRoads: Phaser.GameObjects.Group;
  turnRoads: Phaser.GameObjects.Group;
  loopRoads: Phaser.GameObjects.Group;

  gems: Gem[];

  private straightRoadCount: number;

  private game;

  private currentDirection: Direction;

  private totalTurnCount = 0;
  private levelTurnCount = 0;
  roadCount: number = 0;

  private spriteWidth = 376;

  private mapData;
  private levelData;

  private currentLevel: number = 0;

  lastSpawned: RoadPiece;

  lastSpawnedTurnType: RoadType;

  spawnLevelUp: boolean = false;

  spawnTurn: boolean = false;

  nextLoopInterval: number;

  spawnLevelUpStraightRoads: boolean = false;

  arrows: Phaser.GameObjects.Sprite;

  spawnedLevelUp: boolean;

  constructor(game: Phaser.Scene) {

    this.game = game;

    this.mapData = App.mapData;
    this.levelData = App.levelData;

    this.roadPieces = new Array();
    this.controlPoints = new Array();
    this.gems = new Array()

    this.currentDirection = Direction.up;

    this.straightRoadCount = 3;

    this.nextLoopInterval = this.levelData.LevelData.Loop[this.currentLevel] + Math.floor(Math.random() * 3)

    //Create groups
    this.straightRoads = new Phaser.GameObjects.Group(this.game)
    this.turnRoads = new Phaser.GameObjects.Group(this.game)

    
    this.uRoads = new Phaser.GameObjects.Group(this.game)
    this.loopRoads = new Phaser.GameObjects.Group(this.game)

    this.CreateAndAddRoadPieceToGroup(0, 14);
    this.CreateAndAddRoadPieceToGroup(1, 13);
    this.CreateAndAddRoadPieceToGroup(2, 13);
    this.CreateAndAddRoadPieceToGroup(3, 10);

    this.createGems();

    for (var i = 0; i < 17; i++) {
      this.createRoadPiece();
    }

    this.game.events.on('restart', () => { this.Restart() });

  }

  createGems() {
    for (let i = 0; i < 20; i++) {
      let gem = new Gem(this.game, 0, 0, i);
      gem.gemSprite.setDepth(3);
      gem.gemSprite.setVisible(false)
      this.gems.push(gem);
    }

    this.gems[0].firstGem.setCollisionCategory(Game.disableCollisionLayer)

    var config = {
      key: 'arrowAnimation',
      frames: this.game.anims.generateFrameNumbers('arrow', { start: 0, end: 2, first: 0 }),
      frameRate: 6,
      repeat: -1,
      repeatDelay: 0
    };

    this.game.anims.create(config);
    this.arrows = this.game.add.sprite(0, 0, 'arrow', '0');
    this.arrows.setVisible(false)
    this.arrows.setDepth(2);
    this.arrows.setScale(0.5)
  }

  CreateAndAddRoadPieceToGroup(roadType: RoadType, length?: number) {
    for (let i = 0; i < length; i++) {
      let road = new RoadPiece(this.game, roadType, this);
      switch (roadType) {
        case RoadType.straight: this.straightRoads.add(road, this.game); break;
        case RoadType.uturn: this.uRoads.add(road, this.game); break;
        case RoadType.turn: this.turnRoads.add(road, this.game); break;
        case RoadType.loop: this.loopRoads.add(road, this.game); break;
      }
    }
  }

  createRoadPiece() {

    var props;
    let type;
    // 1. find the road type to spawn
    if (this.straightRoadCount == 0) {

      let spawnLoop = false;
      type = RoadType.turn;

      if (this.spawnLevelUpStraightRoads) {
        this.spawnLevelUpStraightRoads = false;
        this.ChangeLevelDirection();
      }

      if (this.nextLoopInterval <= this.totalTurnCount && this.lastSpawnedTurnType != RoadType.uturn) {
        spawnLoop = true;
        this.nextLoopInterval = this.totalTurnCount + this.levelData.LevelData.Loop[this.currentLevel] + Math.floor(Math.random() * 3);
      }
      if (Game.currentGameDirection == this.currentDirection) {
        //  Dont spawn u turn
        var rnd = Math.floor(Math.random() * 2);
        if (!spawnLoop) {
          type = 1;
        } else {
          type = 3;
          this.spawnTurn = true;
        }
        props = this.mapData.Direction[Game.currentGameDirection][type][this.currentDirection].possibilities[rnd];
      }
      else {

        if (!spawnLoop) {
          if (this.spawnTurn) {
            type = 1;
            this.spawnTurn = false;
          } else {
            type = 1 + Math.floor(Math.random() * 2)
          }
        } else {
          type = 3
          this.spawnTurn = true;
        }
        props = this.mapData.Direction[Game.currentGameDirection][type][this.currentDirection];
      }

      this.levelTurnCount++;


      if (this.levelTurnCount == this.levelData.LevelData.LevelTurnCount[this.currentLevel]) {
        //level up
        if (this.currentLevel < this.levelData.LevelData.LevelTurnCount.length - 1) {
          this.currentLevel++;
        }
        this.nextLoopInterval = this.totalTurnCount + this.levelData.LevelData.Loop[this.currentLevel] + Math.floor(Math.random() * 3);
        this.levelTurnCount = 0;
        this.spawnLevelUp = true; this.spawnLevelUpStraightRoads = true;
        this.straightRoadCount = 1;
      } else {
        this.straightRoadCount = 1 // + Math.floor(Math.random() * 2);
        if (type == 3) {
          this.straightRoadCount = 2;
        }
      }
      this.lastSpawnedTurnType = type;
    }

    //straight
    else {
      type = RoadType.straight;
      var props = this.mapData.Direction[Game.currentGameDirection][type][this.currentDirection];
      this.straightRoadCount--;
    }
    // 2. find its offset and position
    let x, y;
    let straightOffset = { x: 0, y: 0 };
    let depth = 0;
    if (this.roadPieces.length == 0) {
      x = this.game.cameras.main.width / 2;
      y = this.game.cameras.main.height + 200;
    } else {
      if (this.lastSpawned.roadType == RoadType.uturn) {
        let offset = 0.39;
        switch (Game.currentGameDirection) {
          case Direction.left: straightOffset.x -= offset; break;
          case Direction.right: straightOffset.x += offset; break;
          case Direction.up: straightOffset.y -= offset; break;
          case Direction.down: straightOffset.y += offset; break;
        }
        offset = 0.2;
        switch (props.currentDirection) {
          case Direction.down: straightOffset.y -= offset; break;
          case Direction.up: straightOffset.y += offset; break;
          case Direction.left: straightOffset.x += offset; break;
          case Direction.right: straightOffset.x -= offset; break;
        }
      }
      else if (this.lastSpawned.roadType == RoadType.loop) {
        let xDirection = 1, yDirection = 1;
        //Add for all directions
        switch (Game.currentGameDirection) {
          case Direction.left:
            if (this.lastSpawned.angle == 0 || this.lastSpawned.angle == -180)
              yDirection = -1;
            break;
          case Direction.right:
            xDirection = -1;
            if (this.lastSpawned.angle == -90 || this.lastSpawned.angle == 90)
              yDirection = -1;

            break;
          case Direction.up:
            if (this.lastSpawned.angle == 0 || this.lastSpawned.angle == -180)
              xDirection = -1;
            break;
          case Direction.down:
            yDirection = -1;
            if (this.lastSpawned.angle == -90 || this.lastSpawned.angle == 90)
              xDirection = -1;
            break;
        }

        let offset1 = 0.469, offset2 = 0.38;
        switch (props.currentDirection) {
          case Direction.left: straightOffset.y += offset1 * yDirection; straightOffset.x += offset2 * xDirection; break;
          case Direction.right: straightOffset.y += offset1 * yDirection; straightOffset.x += offset2 * xDirection; break;
          case Direction.up: straightOffset.x += offset1 * xDirection; straightOffset.y += offset2 * yDirection; break;
          case Direction.down: straightOffset.x += offset1 * xDirection; straightOffset.y += offset2 * yDirection; break;
        }
        depth = 6;
        //  props.y *= 0.4;
      }

      x = this.lastSpawned.x + (this.spriteWidth * (props.x + straightOffset.x));
      y = this.lastSpawned.y + (this.spriteWidth * (props.y + straightOffset.y));
    }

    // 3. spawn
    let road: any;
    switch (type) {
      case RoadType.straight:
        road = this.GetRoadPiece(this.straightRoads, RoadType.straight); break;
      case RoadType.turn:
        road = this.GetRoadPiece(this.turnRoads, RoadType.turn); break;
      case RoadType.uturn:
        road = this.GetRoadPiece(this.uRoads, RoadType.uturn); break;
      case RoadType.loop:
        road = this.GetRoadPiece(this.loopRoads, RoadType.loop); break;

    }
    if (this.spawnedLevelUp) {
      let width: number = 1334; let height: number = 199;
      if (this.currentDirection == Direction.up || this.currentDirection == Direction.down) {
        height = 1334; width = 199
      }
      x += (props.x * width)
      y += (props.y * height)
      this.spawnedLevelUp = false;
    }

    road.roadIndex = this.roadCount++;
    road.InstantiateRoad(x, y, type)

    if (this.spawnLevelUp && type == RoadType.straight) {

      for (let i = 0; i < 20; i++) {
        this.gems[i].gemSprite.setPosition((props.x * i * 60) + x + (props.x * 250), (props.y * i * 60) + y + (props.y * 250))
        this.gems[i].gemSprite.setVisible(true)
        this.gems[i].gemSprite.alpha = 1;
        this.gems[i].gemSprite.scale = 0.5;
       
      }
      this.gems[0].firstGem.setPosition(this.gems[0].gemSprite.x,this.gems[0].gemSprite.y)
      this.gems[0].firstGem.setCollisionCategory(Game.enableCollisionLayer)
      this.arrows.setPosition(x + (props.x * 750) + (props.x * 100), y + (props.y * 750) + (props.y * 100))

      this.arrows.anims.play('arrowAnimation');
      this.arrows.angle = props.angle;
      this.arrows.setVisible(true)

      this.spawnLevelUp = false;
      this.spawnedLevelUp = true;
      this.straightRoadCount = 1;
    }
    road.angle = props.angle;
    road.setDepth(depth);
    if (depth == 6) {
      road.collider.setCollisionCategory(Game.disableCollisionLayer)
      this.lastSpawned.nextRoad = road;
    }
    road.collider.angle = props.angle;
    if (type != RoadType.straight) {
      this.controlPoints.push(road.setControlPoint(props.angle, props.rotationDirection, props.currentDirection, ++this.totalTurnCount));
    }
    this.roadPieces.push(road);
    this.currentDirection = props.currentDirection;
    this.lastSpawned = road;
  }

  ChangeLevelDirection() {
    let directions: Array<Direction> = [Direction.left, Direction.right, Direction.up, Direction.down]
    directions.splice(this.GetOppositeDirection(this.currentDirection), 1);
    Game.currentGameDirection = directions[Math.floor(Math.random() * 3)];
  }

  GetOppositeDirection(dir: Direction): Direction {
    let oppositeDir;
    switch (dir) {
      case Direction.right: oppositeDir = Direction.left; break;
      case Direction.left: oppositeDir = Direction.right; break;
      case Direction.up: oppositeDir = Direction.down; break;
      case Direction.down: oppositeDir = Direction.up; break;
    }
    return oppositeDir;
  }

  GetRoadPiece(group: Phaser.GameObjects.Group, type: RoadType): RoadPiece {
    let road: RoadPiece;
    if (group.getFirstDead(false)) {
      road = group.get();
    }
    return road;

  }

  Restart() {
    let length = this.roadPieces.length
    for (let i = 0; i < length; i++) {
      this.roadPieces[i].Restart();
    }
    this.roadPieces = [];
    this.controlPoints = [];
    this.currentDirection = Direction.up;
    this.roadCount = this.totalTurnCount = this.levelTurnCount = this.currentLevel = 0;
    this.spawnLevelUp = this.spawnTurn = this.spawnLevelUpStraightRoads = false;
    this.straightRoadCount = 3;


    for (var i = 0; i < 17 i++) {
      this.createRoadPiece();
    }

  }
}
